module.exports = __webpack_public_path__ + "static/media/Votter.7f9302cd.PNG";